import { InjectionToken } from '@angular/core';

/**
 * DI token for the Registry API origin — **without** the `/v1` prefix.
 *
 * The endpoint constants in `@kirigami/data-access/registry-api-contracts`
 * (`REGISTRY_API.*`) are versioned paths (e.g. `/v1/reports/`). Adapters
 * join this origin with those paths at request time:
 *
 *     `${REGISTRY_API_BASE_URL}${REGISTRY_API.reports.list}`
 *
 * Each app provides the token in its `ApplicationConfig` from its own
 * environment file so adapters stay environment-agnostic.
 */
export const REGISTRY_API_BASE_URL = new InjectionToken<string>('REGISTRY_API_BASE_URL');
